import { sdkFactory as wixTableReservationsV1Reservation_sdkFactory_reservations } from './src/table-reservations-v1-reservation.frontend';
import { sdkFactory as wixTableReservationsV1ReservationLocation_sdkFactory_reservationLocations } from './src/table-reservations-v1-reservation-location.frontend';
import { sdkFactory as wixTableReservationsV1TimeSlot_sdkFactory_timeSlots } from './src/table-reservations-v1-time-slot.frontend';
export function sdkFactory(args) {
    return {
        reservations: wixTableReservationsV1Reservation_sdkFactory_reservations(args),
        reservationLocations: wixTableReservationsV1ReservationLocation_sdkFactory_reservationLocations(args),
        timeSlots: wixTableReservationsV1TimeSlot_sdkFactory_timeSlots(args),
    };
}
//# sourceMappingURL=index.frontend.js.map